"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppFormGenerator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var formik_1 = require("formik");
var lodash_1 = __importDefault(require("lodash"));
var react_1 = require("react");
var AppFormGenerator = function (props) {
    var form = props.form, initialValues = props.initialValues, onSubmit = props.onSubmit, wrapperClassNames = props.wrapperClassNames, HeaderElement = props.HeaderElement, FooterElement = props.FooterElement;
    var _a = (0, react_1.useState)(null), init = _a[0], setInit = _a[1];
    (0, react_1.useEffect)(function () {
        var metaInitClone = lodash_1.default.cloneDeep(form.meta.initValues);
        var initClone = lodash_1.default.cloneDeep(initialValues);
        setInit(lodash_1.default.merge(metaInitClone, initClone || {}));
    }, [form.meta.initValues, initialValues]);
    if (!init)
        return (0, jsx_runtime_1.jsx)("span", {});
    return ((0, jsx_runtime_1.jsx)(formik_1.Formik, { enableReinitialize: true, initialValues: init, validationSchema: form.meta.validateSchema, onSubmit: onSubmit, children: (0, jsx_runtime_1.jsxs)(formik_1.Form, { className: wrapperClassNames, children: [HeaderElement, (0, jsx_runtime_1.jsx)(form.Element, {}), FooterElement] }) }));
};
exports.AppFormGenerator = AppFormGenerator;
